import React from 'react'
import PropTypes from 'prop-types'
import { InfoButton } from 'components/buttons'
import { TurnToSnippet, updateSku } from './turnto-snippet'

const ReviewIcon = () => (
  <svg
    role="none"
    width="18"
    height="26"
    className="mrs"
    viewBox="0 0 18 26"
    style={{ marginTop: '-8px' }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" fillRule="evenodd">
      <path
        fill="white"
        stroke="#6E3264"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(-30 -27) translate(30.762 27)"
        d="M2.265 12.069h11.973c.661 0 1.197.536 1.197 1.197v7.184c0 .661-.536 1.198-1.197 1.198H8.73L4.42 25v-3.352H2.265c-.662 0-1.198-.537-1.198-1.198v-7.184c0-.661.536-1.197 1.198-1.197z"
      />
      <path
        fill="#FF7AAB"
        fillRule="nonzero"
        transform="translate(-30 -27) translate(30.762 27)"
        d="M7.278 1.086C7.278.486 7.764 0 8.364 0c.6 0 1.086.486 1.086 1.086v4.562c0 .6-.486 1.086-1.086 1.086-.6 0-1.086-.486-1.086-1.086V1.086zM.318 4.787c-.424-.424-.424-1.112 0-1.536.424-.424 1.112-.424 1.536 0L5.113 6.51c.424.424.424 1.112 0 1.536-.424.424-1.112.424-1.536 0L.318 4.787zM14.982 3.251c.424-.424 1.112-.424 1.536 0 .424.424.424 1.112 0 1.536L13.26 8.046c-.424.424-1.111.424-1.536 0-.424-.424-.424-1.112 0-1.536l3.259-3.259z"
      />
    </g>
  </svg>
)

export const ReviewButton = ({ sku }) => {
  if (!sku) return null
  const handleClick = () => {
    updateSku(sku)
    window.TurnToCmd('reviewsList.writeReview')
  }
  return (
    <>
      <TurnToSnippet sku="" pageId="gift-tracker-review-submission" />
      <InfoButton
        empty
        pill
        size="small"
        onClick={handleClick}
        style={{ fontWeight: 'normal' }}
        className="mtm ptm flex justify-center align-center"
      >
        <ReviewIcon />
        Write A Review
      </InfoButton>
    </>
  )
}

ReviewButton.propTypes = { sku: PropTypes.string.isRequired }
